// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-links {
  line-height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 28 68 / var(--tw-text-opacity));
  transition-duration: 300ms;
  font-weight: 300; }

.footer-links:hover {
  --tw-text-opacity: 1;
  color: rgb(31 67 219 / var(--tw-text-opacity)); }

.footer-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.75rem;
  height: 1.75rem;
  transition-duration: 300ms; }

input {
  padding: 10px;
  color: #ffffff;
  font-weight: 300; }

input:focus {
  outline: none; }

input::placeholder {
  color: #ffffff; }
`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.scss"],"names":[],"mappings":"AACE;EAAA,oBAAM;EACN,oBAAM;EAAN,6CAAM;EACN,0BAAM;EACN,kBAHM;;AAON;EAAA,oBAAM;EAAN,gDAAM;;AAIN;EAAA,aAAM;EACN,uBAAM;EACN,mBAAM;EACN,cAAM;EACN,eAAM;EACN,4BALM;;AAQR;EACE,aAAa;EACb,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,aAAa,EAAA;;AAGf;EACE,cAAc,EAAA","sourcesContent":[".footer-links {\n  @apply leading-9;\n  @apply text-secondary-500;\n  @apply duration-300;\n  @apply font-light;\n}\n\n.footer-links:hover {\n  @apply text-primary-500;\n}\n\n.footer-icon {\n  @apply flex;\n  @apply justify-center;\n  @apply items-center;\n  @apply w-7;\n  @apply h-7;\n  @apply duration-300;\n}\n\ninput {\n  padding: 10px;\n  color: #ffffff;\n  font-weight: 300;\n}\n\ninput:focus {\n  outline: none;\n}\n\ninput::placeholder {\n  color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
